import { createAction, props } from '@ngrx/store';
import { ColumnPreset, CompleteReportPart, Report, ReportPartData, ReportPartDef, ReportPartError, ReportTitle } from './report.model';


interface RequestUpdatePresetProps {
    reportId: string;
    dataSourceKey: string;
    columns: ColumnPreset[];
    saveAsPreset: boolean;
}

interface UpdatePresetProps {
    reportId?: string;
    dataSourceKey: string;
    columns?: ColumnPreset[];
}

interface UpdateCoverProps {
    reportId: string;
    propertyImage: string | null;
    coverType: Report['coverType'];
    showGoogleImages: boolean;
}

interface AddAttachmentProps {
    reportId: string;
    attachment: {
        id: string;
        name: string;
        type: 'file' | 'note';
    };
}

interface CompleteSubPartProps {
    partId: string;
    taskId: string;
    key: string;
    data: any;
}

export const createReport = createAction('[Report] Create report', props<{ upid: string; report: Report }>());

export const updateCover = createAction('[Report] Update cover', props<UpdateCoverProps>());

export const addReportParts = createAction('[Report] Add report parts', props<{ reportId: string; parts: ReportPartDef[] }>());

export const refineReportParts = createAction('[Report] Refine report parts', props<{ reportId: string; parts: ReportPartDef[] }>());

export const completeReportPart = createAction('[Report] Complete report part', props<ReportPartData>());

export const updateReportPart = createAction('[Report] Update report part', props<CompleteReportPart>());

export const failReportPart = createAction('[Report] Fail report part', props<ReportPartError>());

export const removeReportParts = createAction('[Report] Remove report parts', props<{ reportId: string; dataSourceKeys: string[] }>());

export const addSubPart = createAction('[Report] Add sub part', props<{ partId: string; key: string }>());

export const startSubPart = createAction('[Report] Start sub part', props<{ partId: string; key: string; taskId: string }>());

export const completeSubPart = createAction('[Report] Complete sub part', props<CompleteSubPartProps>());

export const failSubPart = createAction('[Report] Fail sub part', props<{ partId: string; taskId: string; error: string; errorMessage?: string }>());

export const removeSubPart = createAction('[Report] Remove sub part', props<{ partId: string; key: string }>());

export const updateMenuPrintability = createAction('[Report] Update menu printability', props<{ menuKey: string; printable: boolean }>());

export const addAttachment = createAction('[Report] add attachment', props<AddAttachmentProps>());

export const updateFavorites = createAction('[Report] Update favorites', props<{ favorites: { [dataSourceKey: string]: any } }>());

export const sortReport = createAction('[Report] Sort report parts', props<{ reportId: string; order: string[] }>());

export const editTitle = createAction('[Report] Change title', props<{ reportId: string; title: ReportTitle }>());

export const requestUpdatePreset = createAction('[Report] Request update preset', props<RequestUpdatePresetProps>());

export const updatePreset = createAction('[Report] Update preset', props<UpdatePresetProps>());
